"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseService_1 = require("./BaseService");
var singleton_1 = require("./singleton");
// https://docs.oracle.com/javase/7/docs/api/java/util/Locale.html
function makeLocale(localeId) {
    switch (localeId // few exceptions
    ) {
        case 'english':
            return 'en-US';
        case 'russian':
            return 'ru-RU';
        case 'en':
            return 'en-US';
        case 'ru':
            return 'ru-RU';
    }
    if (localeId.match(/^(\w\w)[_-](\w\w)$/))
        return RegExp.$1 + '-' + RegExp.$2;
    console.warn("Unknown locale \"" + localeId + "\". Using en-US instead");
    return 'en-US';
}
function makeAppConfig(biSettings) {
    var locale = 'en-US';
    if (typeof biSettings.language === 'string')
        locale = makeLocale(biSettings.language);
    if (typeof biSettings.locale === 'string')
        locale = makeLocale(biSettings.locale);
    locale.match(/^(\w\w)-(\w\w)$/);
    var language = RegExp.$1, region = RegExp.$2;
    var features = Array.isArray(biSettings.features) ? biSettings.features : [];
    var plugins = biSettings.plugins;
    if (!plugins) {
        plugins = [];
        if (biSettings.bookmarksEnabled) {
            plugins.push('presentations');
        }
    }
    return {
        loading: false,
        error: null,
        requestUrls: biSettings.requestUrls,
        projectTitle: typeof biSettings.projectTitle === 'string' ? biSettings.projectTitle : 'Luxms BI',
        locale: locale,
        language: language,
        region: region,
        features: features,
        plugins: plugins,
        dataset: biSettings.dataset || {},
        map: biSettings.map || {}
    };
}
var AppConfig = /** @class */ (function (_super) {
    __extends(AppConfig, _super);
    function AppConfig() {
        return _super.call(this, { loading: true, error: null }) || this;
    }
    AppConfig.prototype.setAppConfig = function (rawAppConfig) {
        this._setModel(makeAppConfig(rawAppConfig));
    };
    AppConfig.prototype.hasFeature = function (featureName) {
        return this._model.features.indexOf(featureName) !== -1;
    };
    /**
     * Replaces parts of URL according to settings
     *
     * @param url URL to proceed
     * @param requestUrls Hash or string of settings
     * @returns {string} resulting URL
     */
    AppConfig.prototype.fixRequestUrl = function (url) {
        var requestUrls = this._model.requestUrls || {};
        console.assert(url.startsWith('/'));
        // find longest rule
        var longestPattern = null;
        for (var strPattern in requestUrls) {
            if (requestUrls.hasOwnProperty(strPattern) && typeof requestUrls[strPattern] === 'string') {
                if (!url.startsWith(strPattern)) {
                    continue;
                }
                if (longestPattern === null || longestPattern.length < strPattern.length) {
                    longestPattern = strPattern;
                }
            }
        }
        if (longestPattern !== null) {
            return requestUrls[longestPattern] + url.slice(longestPattern.length);
        }
        // apply serverUrl
        var baseUrl = typeof requestUrls.serverUrl === 'string' ? requestUrls.serverUrl : '/';
        if (baseUrl === '')
            return url.slice(1);
        if (baseUrl === '/')
            return url;
        if (baseUrl.endsWith('/'))
            baseUrl = baseUrl.slice(0, baseUrl.length - 1);
        return baseUrl + url;
    };
    AppConfig.getModel = function () {
        return this.getInstance().getModel();
    };
    AppConfig.fixRequestUrl = function (url) {
        return this.getInstance().fixRequestUrl(url);
    };
    AppConfig.hasFeature = function (featureName) {
        return this.getInstance().hasFeature(featureName);
    };
    AppConfig.getProjectTitle = function () {
        return this.getModel().projectTitle;
    };
    AppConfig.getLocale = function () {
        return this.getModel().locale;
    };
    AppConfig.getLanguage = function () {
        return this.getModel().language;
    };
    AppConfig.getPlugins = function () {
        return this.getModel().plugins;
    };
    AppConfig.getInstance = singleton_1.createSingleton(function () { return new AppConfig(); }, '__appConfig');
    return AppConfig;
}(BaseService_1.BaseService));
exports.AppConfig = AppConfig;
